var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookmarks = function SvgIconBookmarks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.25 5.75v-2A1.75 1.75 0 0 1 9 2h9a1.75 1.75 0 0 1 1.75 1.75v13.5a1 1 0 0 1-1.61.792L16 16.395V21a1 1 0 0 1-1.61.793l-4.265-3.281-4.265 3.28A1 1 0 0 1 4.25 21V7.5A1.75 1.75 0 0 1 6 5.75zm2 0V4h8.5v11.218L16 13.87V7.5a1.75 1.75 0 0 0-1.75-1.75zM14 14.372v4.597l-3.265-2.512a1 1 0 0 0-1.22 0L6.25 18.97V7.75H14v6.622",
    clipRule: "evenodd"
  })));
};
export default SvgIconBookmarks;